import PropTypes from 'prop-types'
import { compose, setDisplayName, withHandlers, pure } from 'recompose'
import { get, find, isArray } from 'lodash'

import { LIST_SIZES, LIST_TYPES } from 'utils/constants/components/dropdown'
import { PLACEMENT_POSITIONS } from 'utils/constants/components/popover'
import { DropdownListView } from 'components/dropdown/list/DropdownListView'

const handleIsRowSelected =
  ({ value, isRowSelectedFn }) =>
  ({ item }) => {
    if (!isRowSelectedFn) {
      return isArray(value) ? !!find(value, { id: get(item, 'id') }) : get(value, 'id') === get(item, 'id')
    }

    return isRowSelectedFn({ item })
  }

export const DropdownList = compose(
  setDisplayName('DropdownList'),
  pure,
  withHandlers({
    handleIsRowSelected,
  }),
)(DropdownListView)

DropdownList.propTypes = {
  // dropdown
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  onClose: PropTypes.func,
  placement: PropTypes.oneOf(PLACEMENT_POSITIONS),
  width: PropTypes.number,

  // common
  size: PropTypes.oneOf(LIST_SIZES),
  titleKey: PropTypes.string,
  type: PropTypes.oneOf(LIST_TYPES),
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),

  // trigger
  isDisabled: PropTypes.bool,
  isMultiSelect: PropTypes.bool,
  isValid: PropTypes.bool,
  multiSelectTitle: PropTypes.string,
  triggerElementRenderer: PropTypes.func,
  placeholder: PropTypes.string,

  // list
  closeOnSelect: PropTypes.bool,
  isRowSelectedFn: PropTypes.func,
  listItems: PropTypes.array,
  onRowClick: PropTypes.func,
  rowHeight: PropTypes.number,
  rowRenderer: PropTypes.func,

  // reposition
  keysToPositionUpdate: PropTypes.array,
}
